var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ADAAE3",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560-440q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM280-320q-33 0-56.5-23.5T200-400v-320q0-33 23.5-56.5T280-800h560q33 0 56.5 23.5T920-720v320q0 33-23.5 56.5T840-320H280Zm80-80h400q0-33 23.5-56.5T840-480v-160q-33 0-56.5-23.5T760-720H360q0 33-23.5 56.5T280-640v160q33 0 56.5 23.5T360-400Zm440 240H120q-33 0-56.5-23.5T40-240v-440h80v440h680v80ZM280-400v-320 320Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9IiNBREFBRTMiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGQ9Ik01NjAtNDQwcS01MCAwLTg1LTM1dC0zNS04NXEwLTUwIDM1LTg1dDg1LTM1cTUwIDAgODUgMzV0MzUgODVxMCA1MC0zNSA4NXQtODUgMzVaTTI4MC0zMjBxLTMzIDAtNTYuNS0yMy41VDIwMC00MDB2LTMyMHEwLTMzIDIzLjUtNTYuNVQyODAtODAwaDU2MHEzMyAwIDU2LjUgMjMuNVQ5MjAtNzIwdjMyMHEwIDMzLTIzLjUgNTYuNVQ4NDAtMzIwSDI4MFptODAtODBoNDAwcTAtMzMgMjMuNS01Ni41VDg0MC00ODB2LTE2MHEtMzMgMC01Ni41LTIzLjVUNzYwLTcyMEgzNjBxMCAzMy0yMy41IDU2LjVUMjgwLTY0MHYxNjBxMzMgMCA1Ni41IDIzLjVUMzYwLTQwMFptNDQwIDI0MEgxMjBxLTMzIDAtNTYuNS0yMy41VDQwLTI0MHYtNDQwaDgwdjQ0MGg2ODB2ODBaTTI4MC00MDB2LTMyMCAzMjBaIi8+PC9zdmc+";
export { ForwardRef as ReactComponent };